/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Show_Vehicle_Paths_LabelInputs */

const fr_settings_show_vehicle_paths_label = /** @type {(inputs: Settings_Show_Vehicle_Paths_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affichage des tracés`)
};

const en_settings_show_vehicle_paths_label = /** @type {(inputs: Settings_Show_Vehicle_Paths_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Path display`)
};

/**
* | output |
* | --- |
* | "Path display" |
*
* @param {Settings_Show_Vehicle_Paths_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_show_vehicle_paths_label = /** @type {((inputs?: Settings_Show_Vehicle_Paths_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Show_Vehicle_Paths_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_show_vehicle_paths_label(inputs)
	return en_settings_show_vehicle_paths_label(inputs)
});